// extracted by mini-css-extract-plugin
module.exports = {"wrap":"h_3","phone":"h_4","phone-link":"h_5","phoneLink":"h_5"};